import { render, staticRenderFns } from "./LimitCard.template.vue?vue&type=template&id=491804ba&scoped=true&"
var script = {}
import style0 from "./LimitCard.template.vue?vue&type=style&index=0&id=491804ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491804ba",
  null
  
)

export default component.exports